import React from 'react';
import {
  Container,
  SecondWrapper,
  BlocWrapper,
} from 'containers/AmcDetailsPage/PracticalDataBlock/styles';
import PracticalBlock from 'containers/AMCDashboard/practicalBlock/index';

const PracticalDataBlock = () => {
  return (
    <BlocWrapper>
      <Container padding={3}>
        <SecondWrapper container>
          <PracticalBlock mdGrid={12} smGrid={12} />
        </SecondWrapper>
      </Container>
    </BlocWrapper>
  );
};
export default PracticalDataBlock;
